import { Service } from './baseService';

export const getCustomerPortalInstanceService = async (hostname) => {
    const response = await Service.get(`/customer-portal-instances/${hostname}`);
    return response.data;
};
